module.exports = __webpack_public_path__ + "static/media/bpharm3.1df2e01e.jpg";